// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3JoqV","col":"CardReaderDesc_col__10AZp","label":"CardReaderDesc_label__274oF"};